import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  ControlLabel,
  FormGroup,
  Button,
  FormControl,
  Form,
  Checkbox,
  Dropdown,
} from 'react-bootstrap'
import { capitalizeFirstLetter } from '@ExcelFilterRules/utils'

export function Filter({
  filters,
  updateFilterState,
  applyFilterState,
  clearFilters,
}) {
  const [dropdownState, setDropdownState] = useState(false)

  const rules = filters.filter(item => item.category === 'rules')
  const severities = filters.filter(item => item.category === 'severities')
  const text = filters.filter(item => item.type === 'text')
  return (
    <React.Fragment>
      <Dropdown
        id="filter_dropdown_button"
        bsSize="medium"
        open={dropdownState}
        onToggle={() => setDropdownState(prevState => !prevState)}
      >
        <Dropdown.Toggle
          className="btn-myed btn-default-myed btn-sm-myed"
          id="dropdown-toggle"
        >
          <span className="far fa-filter mr-2" aria-hidden="true" />
          Filter
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <div style={{ width: '300px' }}>
            <Form
              className="px-4 py-3 mx-4"
              horizontal
              onSubmit={e => {
                e.preventDefault()
                applyFilterState()
              }}
            >
              <FormGroup>
                <FormGroup>
                  {text.map(item => {
                    return (
                      <React.Fragment key={item.id}>
                        <ControlLabel>
                          <h5>{item.description}</h5>
                        </ControlLabel>
                        <FormControl
                          onSelect={e => e.stopPropagation()}
                          onChange={e =>
                            updateFilterState({
                              type: item.type,
                              payload: {
                                id: e.target.dataset.id,
                                value: e.target.value,
                              },
                            })
                          }
                          data-id={item.id}
                          type="text"
                        />
                      </React.Fragment>
                    )
                  })}
                </FormGroup>

                <ControlLabel>
                  <h5>Severity of Error</h5>
                </ControlLabel>
                <FormGroup>
                  {severities.map(severity => {
                    return (
                      <Checkbox
                        key={severity.id}
                        onClick={e =>
                          updateFilterState({
                            type: 'checkbox',
                            payload: {
                              id: e.target.value,
                            },
                          })
                        }
                        value={severity.id}
                      >
                        {capitalizeFirstLetter(severity.name)}
                      </Checkbox>
                    )
                  })}
                </FormGroup>
                <ControlLabel>
                  <h5>Rules</h5>
                </ControlLabel>
                <FormGroup>
                  {rules.map(rule => {
                    return (
                      <Checkbox
                        key={rule.id}
                        onClick={e =>
                          updateFilterState({
                            type: 'checkbox',
                            payload: {
                              id: e.target.value,
                            },
                          })
                        }
                        value={rule.id}
                      >
                        {rule.name}
                      </Checkbox>
                    )
                  })}
                </FormGroup>
              </FormGroup>
              <Button className="p-2 m-2 btn-primary" type="submit">
                Apply Filters
              </Button>
              <Button className="p-2 m-2" onClick={clearFilters} type="reset">
                Clear Filters
              </Button>
            </Form>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </React.Fragment>
  )
}

Filter.propTypes = {
  filters: PropTypes.array.isRequired,
  updateFilterState: PropTypes.func.isRequired,
  applyFilterState: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
}
